import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import RedemptionDetailModal from './RedemptionDetailModal';

const STATUS_CONFIG = {
  pending: { label: 'Pending', color: 'bg-yellow-100 text-yellow-700', icon: 'Clock' },
  approved: { label: 'Approved', color: 'bg-blue-100 text-blue-700', icon: 'CheckCircle' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-700', icon: 'CheckCircle2' },
  rejected: { label: 'Rejected', color: 'bg-red-100 text-red-700', icon: 'XCircle' },
};

const RedemptionHistory = ({ redemptions, onClose }) => {
  const [selectedRedemption, setSelectedRedemption] = useState(null);

  return (
    <>
      <div className="bg-white rounded-2xl shadow-sm p-5 mb-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-foreground flex items-center space-x-2">
            <Icon name="History" size={18} className="text-amber-500" />
            <span>My Redemptions</span>
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Icon name="X" size={16} className="text-muted-foreground" />
          </button>
        </div>
        {redemptions?.length === 0 ? (
          <div className="text-center py-8">
            <div className="text-4xl mb-3">🎁</div>
            <p className="text-muted-foreground text-sm">No redemptions yet. Start redeeming your stars!</p>
          </div>
        ) : (
          <div className="space-y-3 max-h-64 overflow-y-auto">
            {redemptions?.map(redemption => {
              const status = STATUS_CONFIG?.[redemption?.status] || STATUS_CONFIG?.pending;
              return (
                <button
                  key={redemption?.id}
                  onClick={() => setSelectedRedemption(redemption)}
                  className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-amber-50 rounded-xl transition-colors cursor-pointer text-left group"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center">
                      <Icon name={redemption?.reward?.icon || 'Gift'} size={20} className="text-amber-600" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground text-sm group-hover:text-amber-700 transition-colors">{redemption?.reward?.title || 'Reward'}</p>
                      <p className="text-xs text-muted-foreground">
                        {new Date(redemption?.redeemedAt)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex items-center space-x-1">
                      <span className="text-sm">⭐</span>
                      <span className="text-sm font-semibold text-amber-600">{redemption?.starsSpent}</span>
                    </div>
                    <span className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${status?.color}`}>
                      <Icon name={status?.icon} size={12} />
                      <span>{status?.label}</span>
                    </span>
                    <Icon name="ChevronRight" size={14} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {selectedRedemption && (
        <RedemptionDetailModal
          redemption={selectedRedemption}
          onClose={() => setSelectedRedemption(null)}
        />
      )}
    </>
  );
};

export default RedemptionHistory;
